
//需要注册的表单组件放到这里来
const TestForm = () => import('./TestForm.vue')
const WarehousingHwnysForm = () => import('./WarehousingHwnysForm')
const OutboundHwnysForm = () => import('./OutboundHwnysForm')

export default {
  TestForm,
  WarehousingHwnysForm,
  OutboundHwnysForm
}
